import enterprise from "../../layout/enterpriseHlrj"

// 注意路由格式前缀一定要加/webenterpriseHlrjHlrj
export default {
    path: "/",
    component: enterprise,
    redirect: "/webenterpriseHlrj/homePage",
    alwaysShow: true,
    name: "webenterpriseHlrj",
    children: [
        {
            path: "/webenterpriseHlrj/homePage",
            name: "hlrjHomePage",
            meta: {
                module: "enterpriseHlrj",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:0
            },
            component: () => import("@/webenterpriseHlrj/homePage/index")  
        },
        {
            path: "/webenterpriseHlrj/hlrjBannerDetail",
            name: "hlrjbannerDetail",
            meta: {
                module: "enterpriseHlrj",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                index:0
            },
            component: () => import("@/webenterpriseHlrj/homePage/bannerDetail")  
        },
        {
            path: "/webenterpriseHlrj/cooperate",
            name: "Hlyhcooperate",
            meta: {
                module: "Hlyhcooperate",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:3
            },
            component: () => import("@/webenterpriseHlrj/homePage/cooperate")  
        },
        {
            path: "/webenterpriseHlrj/course",
            name: "Hlrjcourse",
            meta: {
                module: "enterpriseHlrj",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:4
            },
            component: () => import("@/webenterpriseHlrj/enCourse/index")  
        },
        {
            path: "/webenterpriseHlrj/enCourseDetail",
            name: "HlrjenCourseDetail",
            meta: {
                module: "enterpriseHlrj",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:4
            },
            component: () => import("@/webenterpriseHlrj/enCourse/enCourseDetail")  
        },
        {
            path: "/webenterpriseHlrj/enCourseVideo",
            name: "HlrjenCourseVideo",
            meta: {
                module: "enterpriseHlrj",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:4
            },
            component: () => import("@/webenterpriseHlrj/enCourse/enCourseVideo")  
        },{
            path: "/webenterpriseHlrj/enCourseCreateOrder",
            name: "HlrjenCourseCreateOrder",
            meta: {
                module: "enterpriseHlrj",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:4
            },
            component: () => import("@/webenterpriseHlrj/enCourse/enCourseCreOrd")  
        },
        {
            path: "/webenterpriseHlrj/enOrderAdmin",
            name: "HlrjorderAdmin",
            meta: {
                module: "enterpriseHlrj",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:4
            },
            component: () => import("@/webenterpriseHlrj/orderAdmin/index")
        },
        {
            path: "/webenterpriseHlrj/newsInfo",
            name: "newsInfo",
            meta: {
                module: "enterpriseHlrj",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:5
            },
            component: () => import("@/webenterpriseHlrj/homePage/newsInfo")  
        },
        {
            path: "/webenterpriseHlrj/enhelpList",
            name: "enhelpList",
            meta: {
                module: "enterpriseHlrj",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:6
            },
            component: () => import("@/webenterpriseHlrj/enhelpList/index")
        },
        {
            path: "/webenterpriseHlrj/login",
            name: "enHlyhLogin",
            meta: {
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				}
            },
            component: () => import("@/webenterpriseHlrj/auth/login")   
        },
        {
            path: "/webenterpriseHlrj/enhelpdetail",
            name: "enhelpdetail",
            meta: {
                module: "enterpriseHlrj",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				}
            },
            component: () => import("@/webenterpriseHlrj/enhelpdetail/index")
        },
        {
            path: "/webenterpriseHlrj/endowloadDetail",
            name: "endowloadHlyhDetail",
            meta: {
                module: "endowloadHlyhDetail",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:1
            },
            component: () => import("@/webenterpriseHlrj/endowloadDetail/index")
        },
        {
            path: "/webenterpriseHlrj/enCert",
            name: "enCert",
            meta: {
                module: "enCert",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:1
            },
            component: () => import("@/webenterpriseHlrj/enCert/index")
        }, {
            path: "/webenterpriseHlrj/mobileIndex",
            name: "mobileIndex",
            meta: {
                module: "enCert",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:1
            },
            component: () => import("@/webenterpriseHlrj/enCert/mobileIndex")
        },
        {
            path: "/webenterpriseHlrj/searchCert",
            name: "searchCert",
            meta: {
                module: "enCert",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:8
            },
            component: () => import("@/webenterpriseHlrj/enCert/searchCert")
        },
        {
            path: "/webenterpriseHlrj/enTouch",
            name: "enTouch",
            meta: {
                module: "enTouch",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:1
            },
            component: () => import("@/webenterpriseHlrj/enTouch/index")
        },{
            path: "/webenterpriseHlrj/enTouchDetail",
            name: "enTouchDetail",
            meta: {
                module: "enTouch",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:1
            },
            component: () => import("@/webenterpriseHlrj/enTouch/enTouchDetail")
        },
        {
            path: "/webenterpriseHlrj/creatOrder",
            name: "creatOrderHlyh",
            meta: {
                module: "endowloadHlyhDetail",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
            },
            component: () => import("@/webenterpriseHlrj/endowloadDetail/creatOrder/index")
        },
        {
            path: "/webenterpriseHlrj/buyOrder",
            name: "buyOrderHlyh",
            meta: {
                module: "endowloadHlyhDetail",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				}
            },
            component: () => import("@/webenterpriseHlrj/endowloadDetail/buyOrder/index")
        },{
            path: "/webenterpriseHlrj/viewpay",
            name: "viewpay",
            meta: {
                module: "endowloadDetail",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				}
            },
            component: () => import("@/webenterpriseHlrj/endowloadDetail/buyOrder/viewpay")
        },
        {
            path: "/webenterpriseHlrj/enSolution",
            name: "enHlyhSolution",
            meta: {
                module: "enHlyhSolution",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                index:2
            },
            component: () => import("@/webenterpriseHlrj/enSolution/index")
        },
        {
            path: "/webenterpriseHlrj/enNewsDetail",
            name: "enNewsHlyhDetail",
            meta: {
                module: "enNewsHlyhDetail",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				}
            },
            component: () => import("@/webenterpriseHlrj/enNewsDetail/index")
        },{
            path: "/webenterpriseHlrj/enCaseDetail",
            name: "enCaseHlyhDetail",
            meta: {
                module: "cooperate",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
            },
            component: () => import("@/webenterpriseHlrj/enCaseDetail/index")
        },
        {
            path: "/webenterpriseHlrj/enAbout",
            name: "enHlyhAbout",
            meta: {
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:7
            },
            component: () => import("@/webenterpriseHlrj/enAbout/Publicindex")
        }, 
        {
            path: "/webenterpriseHlrj/jobHunting",
            name: "jobHunting",
            meta: {
                module: "enAbout",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:7
            },
            component: () => import("@/webenterpriseHlrj/enAbout/jobHunting/index")
        }, {
            path: "/webenterpriseHlrj/jobDetail",
            name: "jobDetail",
            meta: {
                module: "enAbout",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:7
            },
            component: () => import("@/webenterpriseHlrj/enAbout/jobHunting/jobDetail")
        },{
            path: "/webenterpriseHlrj/enSetting",
            name: "enHLyhSetting",
            meta: {
                module: "enHLyhSetting",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                
            },
            component: () => import("@/webenterpriseHlrj/enSetting/index")
        },{
            path: "/webenterpriseHlrj/enBusiness",
            name: "HlrjenBusiness",
            meta: {
                module: "HlrjenBusiness",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                
            },
            component: () => import("@/webenterpriseHlrj/enBusiness/index")
        },{
            path: "/webenterpriseHlrj/inviteAccount",
            name: "inviteAccount",
            meta: {
                module: "enterprise",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                
            },
            component: () => import("@/webenterpriseHlrj/inviteAccount/index")
        },
        {
            path: "/webenterpriseHlrj/adminMobileTransfer",
            name: "adminMobileTransfer",
            meta: {
                module: "enterprise",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                
            },
            component: () => import("@/webenterpriseManage/publicViews/adminMobileTransfer")
        },
        {
            path: "/webenterpriseHlrj/mobileCenter",
            name: "mobileCenter",
            meta: {
                module: "enterprise",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                
            },
            component: () => import("@/webenterpriseManage/publicViews/mobileCenter")
        }
    ]
}